import { render, staticRenderFns } from "./RatingComponent.vue?vue&type=template&id=0f948e33&"
import script from "./RatingComponent.vue?vue&type=script&lang=ts&"
export * from "./RatingComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports